//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[[0,"Orientation",1,0],[0,"PlotQuality",1,0],[0,"SubRegion",1,0]],[[["image_size","x_size","y_size"],"GetImageSize",{},0,0],[["image_size","x_size","y_size"],"SetImageSize",{},3,0],[["dots_per_inch"],"GetResolution",{R_:{resolution:''}},0,0],[["resolution","dots_per_inch"],"SetResolution",{},2,0]],[]];
SPLM.Preferences.SessionVisualizationHighQualityImage = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.SessionVisualizationHighQualityImage";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.SessionVisualizationHighQualityImage.ImageSizeType = Object.freeze({
    "FillView" : "FillView", "AnsiA" : "AnsiA", "AnsiB" : "AnsiB", "AnsiC" : "AnsiC", "AnsiD" : "AnsiD", "AnsiE" : "AnsiE", "IsoA4" : "IsoA4", "IsoA3" : "IsoA3", "IsoA2" : "IsoA2", "IsoA1" : "IsoA1", "IsoA0" : "IsoA0", "UserDefined" : "UserDefined", "TrueSize" : "TrueSize"});

SPLM.Preferences.SessionVisualizationHighQualityImage.ResolutionType = Object.freeze({
    "Draft" : "Draft", "Low" : "Low", "Medium" : "Medium", "High" : "High", "UserDefined" : "UserDefined"});

SPLM.Preferences.SessionVisualizationHighQualityImage.PlotQualityType = Object.freeze({
    "Fine" : "Fine", "Medium" : "Medium", "Rough" : "Rough", "Coarse" : "Coarse"});

SPLM.Preferences.SessionVisualizationHighQualityImage.OrientationType = Object.freeze({
    "Landscape" : "Landscape", "Portrait" : "Portrait"});

export default SPLM;